import React, { Component } from 'react';

export class BaseCheckBox extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let disabledStyle = "";
        if (this.props.disabled === true) {
            disabledStyle = "bg-gray-200 ";
        }
        
        return (
            <input type="checkbox" {...this.props} className={disabledStyle + "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded " + this.props.classnames}>
            </input>
        )

    }
}

export class ExpandCheckBox extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let disabledStyle = "";
        if (this.props.disabled === true) {
            disabledStyle = "bg-gray-200 ";
        }

        return (
            <input type="checkbox" {...this.props} className={disabledStyle + "m-1 focus:ring-indigo-500 h-6 w-6 text-indigo-600 border-gray-300 rounded " + this.props.classnames}>
            </input>
        )

    }
}

